import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';
import { ReportsComponent } from '../reports.component';

@Component({
    selector: 'app-add-report',
    templateUrl: './add-report.component.html',
    styleUrls: ['./add-report.component.scss'],
    standalone: false
})
export class AddReportComponent implements OnInit {


  reportName: string = '';

  constructor(private service: AppService, @Inject('BASE_URL') private baseUrl: string, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, public dialogRef: MatDialogRef<ReportsComponent>, private dialog: MatDialog) { }

  ngOnInit() {
  }

  /** Click event for the save button */
  OnSaveReport() {
    this.service.showSpinner();
    this.http.get<GRSSResponse>(this.baseUrl + 'api/reports/addReport/' + this.reportName).subscribe(result => {
      if (result.statusCode === 4) {
        this.service.SaveStatus(true, 'Reports.Messages.msgHeaderNew', result.statusMessage);
      } else {
        if (result.statusCode === 1) {
          this.dialogRef.close(this.reportName);
        }
        this.service.SaveStatus(false, 'Reports.Messages.msgHeaderNew', result.statusMessage);
      }
    }, error => {
      console.error(error);
    }).add(() => {
      this.service.hideSpinner();
    });
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close('');
  }

}
